import CardPage from './CardPage';

export default CardPage;
